export default __webpack_public_path__ + "static/char-s-02-cht-11be80f5ee50868933718ea3fbb1b557.webp";